/*
* Created on Jul 27, 2020
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import Backend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import LanguageDetector from "i18next-browser-languagedetector";


i18n.use(ChainedBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            backends: [
                LocalStorageBackend,
                Backend
            ],
            backendOptions: [{
                expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 days
            }, {
                loadPath: '/qcloud-l10n/json/{{lng}}.json'
            }]
        },
        // backend: backendOptions,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        debug: false,
        keySeparator: false,
        nsSeparator: false,
        react: {
            useSuspense: true,
        },
        loadPath: '/qcloud-l10n/json/{{lng}}.json'
    });

export default i18n;